import { useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $userCardsStore } from '@lib/store/userManagement';
import { cn, FormatUtils } from '@shared/utils';
import type { UserResponse } from '@shared/api/rest/users';
import { Button, ColorsEnum, Icon, Modal, Text } from '@shared/widgets';
import CrossIcon from '@assets/icons/cross.svg';

interface IRemoveCardsProps {
  show: boolean;
  onClose: () => void;
  userData: UserResponse;
}

export const RemoveCardsModal = (props: IRemoveCardsProps) => {
  const userCardsStore = useUnit($userCardsStore.store);

  const [selectedCards, setSelectedCards] = useState<number[]>([]);

  const { t } = useTranslation('user');

  const closeHandler = () => {
    setSelectedCards([]);
    props.onClose();
  };
  const confirmRemoveHandler = async () => {
    if (!selectedCards.length) {
      closeHandler();
      return;
    }
    await $userCardsStore.events.deleteCard({ userIds: props.userData.id, cardIds: selectedCards });
    closeHandler();
  };

  return (
    <Modal isOpen={props.show} onClose={closeHandler} title={t('modals.removeCards.title')}>
      <div className='flex flex-col gap-2'>
        {userCardsStore.data.data.map((card, idx) => (
          <div
            key={idx}
            className={cn(
              'flex w-full items-center justify-between rounded-sm bg-white p-2 pl-3 dark:bg-slate',
              selectedCards.includes(card.cardId) && 'pointer-events-none opacity-50',
            )}
          >
            <div className='shrink pr-4'>
              <Text className='text-ellipsis' size='sm'>
                {FormatUtils.toSliceNumber(card.cardNumber, 16)}
              </Text>
              <Text className='text-ellipsis' size='xs' color={ColorsEnum.Gray}>
                {card.cardHolder}
              </Text>
            </div>
            <Button className='p-0' color='icon' onClick={() => setSelectedCards((prev) => [...prev, card.cardId])}>
              <Icon icon={<CrossIcon className='h-6 w-6' />} color='red' />
            </Button>
          </div>
        ))}
      </div>
      <Button className='mt-5' color='primary' fullWidth disabled={userCardsStore.loading} onClick={confirmRemoveHandler}>
        {t('buttons.confirm', { ns: 'common' })}
      </Button>
    </Modal>
  );
};
